//import "./App.css";
//import "./_metronic/assets/sass/style.react.scss";
//import "./_metronic/assets/fonticon/fonticon.css";
//import "./_metronic/assets/keenicons/duotone/style.css";
//import "./_metronic/assets/keenicons/outline/style.css";
//import "./_metronic/assets/keenicons/solid/style.css";
//import "./_metronic/assets/sass/style.scss";
//import "bootstrap/dist/css/bootstrap.min.css"; //because it is imported in eyeconxcss
import "./_theme/eyeconx.scss"
import "bootstrap-icons/font/bootstrap-icons.css";
import "boxicons/css/boxicons.min.css";
import "remixicon/fonts/remixicon.css";
import "./_theme/css/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import { Routes, Route, BrowserRouter } from "react-router-dom";
import AuthLayout from "./components/layout/AuthLayout";
import Login from "./components/auth/Login";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import TermsConditions from "./components/auth/TermsConditions";
import ContactUs from "./components/auth/ContactUs";
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./components/pages/dashboard/Dashboard";
import StateObject from "./components/helpers/StateObject";
import PrivateRoutes from "./routings/PrivateRoutes";
import Appointments from './components/pages/appointments/Appointments'
import PatientFiles from "./components/pages/patientfiles/PatientFiles";
import Surveys from "./components/pages/surveys/Surveys";
import Articles from "./components/pages/articles/Articles";
import Newsletter from "./components/pages/newsletter/Newsletter";
import EyeDrawNew from "./components/pages/eyedraw/EyeDrawNew";
import MyActivity from "./components/pages/myactivity/MyActivity";
import MyFiles from "./components/pages/myfiles/MyFiles";
import Settings from "./components/pages/settings/Settings";
import ArticlePrint from "./components/pages/articles/ArticlePrint";
import Messages from "./components/pages/messages/Messages";
import EmailBlast from "./components/pages/blast_email/EmailBlast";
import SmsBlast from "./components/pages/blast_sms/SmsBlast";
import CreateEmail from "./components/pages/blast_email/CreateEmail";
import CreateSms from "./components/pages/blast_sms/CreateSms";
import ClinicSettings from "./components/pages/settings/ClinicSettings";
import SmsDashboard from "./components/smsgateway/pages/smsdashboard/SmsDashboard";
import SmsMessages from "./components/smsgateway/pages/messages/SmsMessages";
import SmsLayout from "./components/smsgateway/layout/SmsLayout";
import SmsChangePassword from "./components/smsgateway/pages/account/SmsChangePassword";
import SmsConversation from "./components/smsgateway/pages/messages/SmsConversation";
import GatewayClinicInfo from "./components/smsgateway/pages/clinicsettings/GatewayClinicInfo";
import Notifications from "./components/smsgateway/pages/notifications/Notifications";
import SmsHelp from "./components/smsgateway/pages/help/SmsHelp";
import Logout from "./components/auth/Logout";
import ReminderSettings from "./components/pages/settings/reminders/ReminderSettings";
import EmailNewsLetter from "./components/pages/newsletter/email/EmailNewsLetter";
import EmailEditorTest from "./components/helpers/email-editor/EmailEditorTest";
import CreateSurveyPage from "./components/pages/surveys/CreateSurveyPage";
import SurveyTemplate from "./components/pages/surveys/SelectTemplate";
import SurveyPublishPage from './components/pages/surveys/SurveyPublishPage';
import SurveyResultPage from "./components/pages/surveys/SurveyResultPage";
import Features from "./components/pages/settings/features/Features";
import UserSettings from "./components/pages/settings/users/UserSettings";
import PasswordUpdate from "./components/pages/password/PasswordUpdate";
import Reputation from "./components/pages/reputation/Reputation";
import Bookings from "./components/pages/bookings/Bookings";
import Patient from "./components/pages/patientfiles/patient/Patient";
import Templates from "./components/pages/templates/Templates";
import Activity from "./components/pages/settings/activity/Activity";
function App() {

  return (
    <BrowserRouter>
      <Routes>

          {/** public routes */}
        <Route element={<AuthLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="terms-and-conditions" element={<TermsConditions />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="logout" element={<Logout/>} />
        </Route>

        <Route element={<MainLayout/>}>
            <Route element={<PrivateRoutes/>}>
                <Route path="dashboard" element={<Dashboard/>}/>
                <Route path="appointments" element={<Appointments/>}/>
                <Route path="web-bookings" element={<Bookings/>}/>
                <Route path="patient-files">
                    <Route index element={<PatientFiles/>}/>
                    <Route path=":patientId" element={<Patient/>}/>
                </Route>
                <Route path="surveys">
                    <Route index element={<Surveys/>}/>
                    <Route path=":surveyId" element={<Surveys/>}/>
                    <Route path=":surveyId/results" element={<SurveyResultPage/>}/>
                    <Route path="survey-templates" element={<SurveyTemplate/>}/>
                    <Route path="survey-publish" element={<SurveyPublishPage/>} />
                    <Route path="create-survey" element={<CreateSurveyPage/>}/>


                </Route>
                <Route path="messages" element={<Messages/>} /> 
               {/*} <Route path="messages">
                    <Route index element={<SmsMessages/>} />
                    <Route path=":conversationId" element={<SmsConversation/>}/> 
                </Route>*/}
                <Route path="articles" element={<Articles/>}/>
                <Route path="newsletter">
                        <Route path="email-newsletter" element={<EmailNewsLetter/>}/>
                        <Route path="sms-newsletter" element={<Newsletter/>}/>
                        
                </Route>
                <Route path="blast">
                  <Route path="email" element={<EmailBlast/>} />
                  <Route path="create-email" element={<CreateEmail/>} />
                  <Route path="sms" element={<SmsBlast/>} />
                  <Route path="create-sms" element={<CreateSms/>}/>

                </Route>
                <Route path="reputation" element={<Reputation/>}/>
                <Route path="email-editor-test" element={<EmailEditorTest/>} />
                <Route path="eye-draw" element={<EyeDrawNew/>}/>
                <Route path="activity" element={<MyActivity/>}>

                </Route>
                <Route path="my-files" element={<MyFiles/>}/>
                <Route path="settings">
                    <Route path="clinic" element={<ClinicSettings/>}/>
                    <Route path="clinic-info" element={<Settings/>}/>
                    <Route path="reminders" element={<ReminderSettings/>} />
                    <Route path="features" element={<Features/>} />
                    <Route path="users" element={<UserSettings/>} />
                    <Route path="templates" element={<Templates/>} />
                    <Route path="activity" element={<Activity/>}/>
                </Route>
                <Route path="update-password" element={<PasswordUpdate/>} />
            </Route>
        </Route>
        {/** sms gateway routes */}
        <Route element={<PrivateRoutes/>}>
          <Route element={<SmsLayout/>}>
          <Route path="sms-dashboard" element={<SmsDashboard/>} />
          <Route path="sms-messages">
              <Route index element={<SmsMessages/>} />  
              <Route path=":conversationId" element={<SmsConversation/>}/>     
          </Route> 
          <Route path="sms-clinic-settings" element={<GatewayClinicInfo/>} />
          <Route path="sms-change-password" element={<SmsChangePassword/>} />
          <Route path="sms-help" element={<SmsHelp/>} />
          <Route path='sms-notifications' element={<Notifications/>} />
        </Route>
        </Route>
        {/** end sms routes */}
        <Route element={<PrivateRoutes/>}>
           {/* Doesnt have main layout. Full Screen  */}
           <Route path="print-article">
              <Route path=":articleId" element={<ArticlePrint/>} />
           </Route>
        </Route>

      <Route path="eyedraw" element={<EyeDrawNew/>}/>

        <Route path="stateobject" element={<StateObject/>} />
      </Routes>
      <ToastContainer position="bottom-right"/>
    </BrowserRouter>
  );
}

export default App;
